export default {
  model: [
    {
      label: 'Nome',
      field: 'name',
      type: 'text'
    },
    {
      label: 'Descrição',
      field: 'description',
      type: 'text'
    },
    {
      label: 'Ordem',
      field: 'order',
      type: 'text'
    },
    {
      label: 'Descrição detalhada',
      field: 'detailed_description',
      type: 'text'
    },
    {
      label: 'Detalhes da Publicação',
      field: 'details',
      type: 'text'
    },
    {
      label: 'Capa ',
      field: 'image',
      type: 'text',
      condition_field: 'id',
      condition_type_exists: false
    }
  ]
}
